
import React from 'react';
import { Result, Button, Card, Space, Typography } from 'antd';
import { 
  ReloadOutlined, 
  HomeOutlined, 
  BugOutlined 
} from '@ant-design/icons';
import { useErrorBoundary } from './useErrorBoundary';

const { Text, Paragraph } = Typography;

const ErrorBoundary = ({ children, fallback }) => {
  const { 
    error, 
    errorInfo, 
    hasError, 
    resetError, 
    setErrorWithInfo  
  } = useErrorBoundary();

  
  React.useEffect(() => {
    const handleGlobalError = (event) => {
      event.preventDefault();
      setErrorWithInfo(event.error); 
    };

    const handleUnhandledRejection = (event) => {
      event.preventDefault();
      setErrorWithInfo(event.reason); 
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [setErrorWithInfo]); 

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  if (hasError) {
    if (fallback) {
      return React.cloneElement(fallback, { 
        error, 
        errorInfo, 
        onReset: resetError 
      });
    }

    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '20px',
        backgroundColor: '#f5f5f5'
      }}>
        <Card style={{ maxWidth: 600, width: '100%' }}>
          <Result
            status="error"
            title="Đã xảy ra lỗi!"
            subTitle="Xin lỗi, đã có lỗi không mong đợi xảy ra."
            icon={<BugOutlined style={{ color: '#ff4d4f' }} />}
            extra={[
              <Space key="actions" direction="vertical" style={{ width: '100%' }}>
                <Button
                  type="primary"
                  icon={<ReloadOutlined />}
                  onClick={resetError}
                  size="large"
                  block
                >
                  Thử lại
                </Button>,
                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleReload}
                  size="large"
                  block
                >
                  Tải lại trang
                </Button>,
                <Button
                  icon={<HomeOutlined />}
                  onClick={handleGoHome}
                  size="large"
                  block
                >
                  Về trang chủ
                </Button>
              </Space>
            ]}
          />

          {/* Hiển thị chi tiết lỗi trong development */}
          {process.env.NODE_ENV === 'development' && errorInfo && (
            <Card 
              title="Chi tiết lỗi (Development)" 
              size="small"
              style={{ marginTop: 20 }}
            >
              <Paragraph>
                <Text strong>Error: </Text>
                <Text code>{error?.toString()}</Text>
              </Paragraph>
              <Paragraph>
                <Text strong>Component Stack: </Text>
              </Paragraph>
              <pre style={{ 
                backgroundColor: '#f0f0f0', 
                padding: '12px', 
                borderRadius: '6px',
                overflow: 'auto',
                fontSize: '12px'
              }}>
                {errorInfo.componentStack || errorInfo.toString()}
              </pre>
            </Card>
          )}
        </Card>
      </div>
    );
  }

  return children;
};

export default ErrorBoundary;